var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Flat",
    enableBackground: "new 0 0 496 496",
    height: 512,
    viewBox: "0 0 496 496",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m464.99 0h-34.22c-13.563 8.376-26.337 8.825-38.19 0h-34.29c-11.535 13.169-21.755 14.525-30.21 0h-36.2c-9.591 13.255-24.964 11.291-43.88 0h-43.88c-5.874 12.922-18.563 11.624-36.2 0h-30.21c-12.195 9.435-23.745 10.914-34.29 0h-38.19c-13.251 15.489-24.766 16.4-34.22 0h-31.01v107.05c9.542 6.669 6.677 14.514 0 22.72v160.61c7.603 7.993 7.603 15.987 0 23.98v110.02c10.584 9.975 12.161 19.438 0 28.12 10.635 7.25 10.635 14.5 0 21.75 9.162 7.25 9.162 14.5 0 21.75 191.4-6.94 371.386-10.841 496 0-13.357-7.25-13.357-14.5 0-21.75-7.103-6.053-8.522-13.064 0-21.75-11.207-10.462-14.776-20.183 0-28.12v-110.02c-9.747-7.993-9.747-15.987 0-23.98v-160.61c-4.156-7.836-4.468-15.429 0-22.72l-9.922-95.091z",
    fill: "#e15c63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m460.58 314.36-26.82 53.71h-371.52l-26.82-53.71c6.62 0 11.99-5.37 11.99-11.99 0-3.31-1.34-6.31-3.51-8.48s-5.17-3.51-8.48-3.51c42.01-60.41 64.27-129.69 64.27-208.53 37.42 26.86 105.94 47.4 148.31 47.4s110.89-20.54 148.31-47.4c0 78.84 22.26 148.12 64.27 208.53-3.31 0-6.31 1.34-8.48 3.51s-3.51 5.17-3.51 8.48c0 6.62 5.37 11.99 11.99 11.99z",
    fill: "#524956"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 474.25h496v21.75h-496z",
    fill: "#5d5560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 452.5h496v21.75h-496z",
    fill: "#655f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496 424.38v28.12h-496v-28.12s17.49 0 27.07-9.08c9.58-9.07 1.47-23.4 6.16-32.85.87-1.74 1.97-3.33 3.28-4.76 5.8-6.34 15.58-9.62 25.73-9.62h371.52c10.15 0 19.93 3.28 25.73 9.62 1.31 1.43 2.41 3.02 3.28 4.76 4.69 9.45-3.42 23.78 6.16 32.85 9.58 9.08 27.07 9.08 27.07 9.08z",
    fill: "#e0ac69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m477.87 314.36-18.38 63.33c-5.8-6.34-15.58-9.62-25.73-9.62l26.82-53.71z",
    fill: "#c43b58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.42 314.36 26.82 53.71c-10.15 0-19.93 3.28-25.73 9.62l-18.38-63.33z",
    fill: "#c43b58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496 314.36-27.07 100.94c-9.58-9.07-1.47-23.4-6.16-32.85-.87-1.74-1.97-3.33-3.28-4.76l18.38-63.33z",
    fill: "#d14b62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.13 314.36 18.38 63.33c-1.31 1.43-2.41 3.02-3.28 4.76-4.69 9.45 3.42 23.78-6.16 32.85l-27.07-100.94z",
    fill: "#d14b62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496 314.36v110.02s-17.49 0-27.07-9.08z",
    fill: "#e15c63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496 290.38v23.98h-18.13-17.29c-6.62 0-11.99-5.37-11.99-11.99 0-3.31 1.34-6.31 3.51-8.48s5.17-3.51 8.48-3.51z",
    fill: "#ffc05a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496 290.38h-35.42c-42.01-60.41-64.27-129.69-64.27-208.53 23.35 23.2 57.74 38.33 99.69 47.92z",
    fill: "#e15c63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.13 101.73c12.2-2.98 24.76-6.82 37-11.31 10.37-3.79 20.5-8.04 30-12.62 12.03-5.79 23.03-12.11 32.18-18.68 10.71 10.65 23.76 19.59 38.79 27.08 11.32 5.65 23.76 10.47 37.19 14.56 7.59 2.33 15.51 4.41 23.71 6.29v22.72c-41.95-9.59-76.34-24.72-99.69-47.92-37.42 26.86-105.94 47.4-148.31 47.4s-110.89-20.54-148.31-47.4c-23.35 23.2-57.74 38.33-99.69 47.92v-22.72c8.2-1.88 16.12-3.96 23.71-6.29 13.43-4.09 25.87-8.91 37.19-14.56 15.03-7.49 28.08-16.43 38.79-27.08 9.15 6.57 20.15 12.89 32.18 18.68 9.5 4.58 19.63 8.83 30 12.62 12.24 4.49 24.8 8.33 37 11.31 17.87 4.38 34.97 6.92 49.13 6.92s31.26-2.54 49.13-6.92z",
    fill: "#ffc05a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496 0v107.05c-8.2-1.88-16.12-3.96-23.71-6.29l-7.3-100.76z",
    fill: "#d14b62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m464.99 0 7.3 100.76c-13.43-4.09-25.87-8.91-37.19-14.56l-4.33-86.2z",
    fill: "#e15c63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.77 0 4.33 86.2c-15.03-7.49-28.08-16.43-38.79-27.08l-3.73-59.12z",
    fill: "#d14b62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392.58 0 3.73 59.12c-9.15 6.57-20.15 12.89-32.18 18.68l-5.84-77.8z",
    fill: "#e15c63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.29 0 5.84 77.8c-9.5 4.58-19.63 8.83-30 12.62l-6.05-90.42z",
    fill: "#d14b62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328.08 0 6.05 90.42c-12.24 4.49-24.8 8.33-37 11.31l-5.25-101.73z",
    fill: "#e15c63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.88 0 5.25 101.73c-17.87 4.38-34.97 6.92-49.13 6.92v-108.65z",
    fill: "#d14b62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248 0v108.65c-14.16 0-31.26-2.54-49.13-6.92l5.25-101.73z",
    fill: "#e15c63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.12 0-5.25 101.73c-12.2-2.98-24.76-6.82-37-11.31l6.05-90.42z",
    fill: "#d14b62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.92 0-6.05 90.42c-10.37-3.79-20.5-8.04-30-12.62l5.84-77.8z",
    fill: "#e15c63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m137.71 0-5.84 77.8c-12.03-5.79-23.03-12.11-32.18-18.68l3.73-59.12z",
    fill: "#d14b62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.42 0-3.73 59.12c-10.71 10.65-23.76 19.59-38.79 27.08l4.33-86.2z",
    fill: "#e15c63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 290.38v-160.61c41.95-9.59 76.34-24.72 99.69-47.92 0 78.84-22.26 148.12-64.27 208.53z",
    fill: "#e15c63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.23 0-4.33 86.2c-11.32 5.65-23.76 10.47-37.19 14.56l7.3-100.76z",
    fill: "#d14b62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.9 293.89c2.17 2.17 3.51 5.17 3.51 8.48 0 6.62-5.37 11.99-11.99 11.99h-17.29-18.13v-23.98h35.42c3.31 0 6.31 1.34 8.48 3.51z",
    fill: "#ffc05a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.01 0-7.3 100.76c-7.59 2.33-15.51 4.41-23.71 6.29v-107.05z",
    fill: "#e15c63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 314.36 27.07 100.94c-9.58 9.08-27.07 9.08-27.07 9.08z",
    fill: "#e15c63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m496 424.38v28.12c-40.29-1.26-57.94-28.21-56.96-52.77s-34.38-30.36-34.38-30.36v-1.3h29.1c10.15 0 19.93 3.28 25.73 9.62 1.31 1.43 2.41 3.02 3.28 4.76 4.69 9.45-3.42 23.78 6.16 32.85 9.58 9.08 27.07 9.08 27.07 9.08z",
    fill: "#d19d65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.36 368.07v1.3c-30.45 1.3-26.52 3.84-32.42 38.12-5.89 34.28-55.94 45.01-55.94 45.01v-28.12s17.49 0 27.07-9.08c9.58-9.07 1.47-23.4 6.16-32.85.87-1.74 1.97-3.33 3.28-4.76 5.8-6.34 15.58-9.62 25.73-9.62z",
    fill: "#d19d65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.27 137.37c-21.09-11.37-34.63-22.66-34.63-22.66h-.01c-.87-10.77-1.32-21.72-1.32-32.86 23.35 23.2 57.74 38.33 99.69 47.92v29.58c-24.11-3.27-46.45-12.65-63.73-21.98z",
    fill: "#d14b62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.69 81.85c0 9.06-.29 17.99-.88 26.8h-.01c-10.82 10.37-23 18.41-35.01 24.64-32.5 16.85-63.79 20.37-63.79 20.37v-23.89c41.95-9.59 76.34-24.72 99.69-47.92z",
    fill: "#d14b62"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#c43b58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.764 130.138c-2.184-.29-4.209 1.221-4.515 3.408-6.444 46.108-19.324 92.069-38.282 136.606-.865 2.032.082 4.382 2.114 5.247.511.218 1.042.32 1.564.32 1.556 0 3.035-.913 3.683-2.435 19.233-45.184 32.302-91.826 38.844-138.632.305-2.186-1.22-4.208-3.408-4.514z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.1 155.35c-2.209 0-4 1.791-4 4 0 35.83-4.686 70.954-13.928 104.397-.588 2.129.661 4.332 2.79 4.921.356.099.715.146 1.068.146 1.754 0 3.363-1.163 3.853-2.936 9.434-34.137 14.217-69.979 14.217-106.528 0-2.209-1.791-4-4-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m438.813 152.761c-.942-5.295-1.812-10.668-2.591-16.007-.166-1.066-.323-2.132-.469-3.199-.3-2.188-2.319-3.718-4.507-3.418-2.188.301-3.719 2.319-3.418 4.508.153 1.114.317 2.229.485 3.303.785 5.383 1.668 10.838 2.625 16.216 7.412 41.648 20.091 83.249 37.684 123.647.656 1.506 2.126 2.404 3.669 2.404.533 0 1.075-.107 1.595-.334 2.025-.882 2.952-3.238 2.07-5.264-17.343-39.825-29.84-80.823-37.143-121.856z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m495.185 275.195c-11.47-36.972-17.285-75.948-17.285-115.846 0-2.209-1.791-4-4-4s-4 1.791-4 4c0 40.702 5.937 80.476 17.645 118.217.532 1.715 2.113 2.815 3.819 2.815.393 0 .792-.059 1.187-.181 2.109-.653 3.289-2.894 2.634-5.005z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage);
export default __webpack_public_path__ + "static/media/stage.2c8356fce97a4eb052cfdcdc7b398912.svg";
export { ForwardRef as ReactComponent };